import { PopupConfig } from '../../context/PopupManagerContext';
import DynamicPage from '../../pages/DynamicPage';
/**
 * Popup Registry - Central registry of all popups in the application
 * Each popup is defined with:
 * - id: Unique identifier
 * - priority: Higher number = higher priority (shown first)
 * - condition: Function that determines if popup should be shown
 * - component: React component to render
 * - props: Props to pass to the component (can be static values or functions)
 * - storageKey: Key for localStorage tracking
 */

export const popupRegistry: PopupConfig[] = [
  {
    id: 'onboarding_petszel_disabled',
    priority: 1,
    condition: (state) => {
      // Show when petszel is disabled
      return Boolean(state.shelter && !state.shelter?.is_petszel_enabled);
    },
    component: DynamicPage,
    props: {
      slug: 'first-time-user-welcome',
      welcomeFlowTracking: {
        quizName: 'welcome flow manual',
        questionNames: ['tour new portal', 'unleash partner perks', 'easily submit reports'],
      },
    },
    storageKey: 'onboarding_petszel_disabled',
  },
  {
    id: 'onboarding_petszel_enabled',
    priority: 1,
    condition: (state) => {
      // Show when petszel is enabled and they havent seen the "Disabled" modal
      const disabledModalSeen = localStorage.getItem('popup:onboarding_petszel_disabled:dismissed');
      return Boolean(state.shelter?.is_petszel_enabled && !disabledModalSeen);
    },
    component: DynamicPage,
    props: {
      slug: 'first-time-user-welcome-automated',
      welcomeFlowTracking: {
        quizName: 'welcome flow automated',
        questionNames: ['tour new portal', 'unleash partner perks', 'automation enabled'],
      },
    },
    storageKey: 'onboarding_petszel_enabled',
  },
  {
    id: 'automated_reporting_confirmation_status_modal',
    priority: 1,
    condition: (state) => {
      // Show when petszel is enabled and they previously saw the "Disabled" modal (transitioned from manual)
      const disabledModalSeen = localStorage.getItem('popup:onboarding_petszel_disabled:dismissed');
      return Boolean(state.shelter?.is_petszel_enabled && disabledModalSeen);
    },
    component: DynamicPage,
    props: {
      slug: 'automated-reporting-confirmation-status-modal',
    },
    storageKey: 'automated_reporting_confirmation_status_modal',
  },
];

/**
 * Helper function to get popup by ID
 */
export const getPopupById = (id: string): PopupConfig | undefined => {
  return popupRegistry.find((popup) => popup.id === id);
};
